<div class="dialog-container" role="dialog" aria-label="Generative AI Usage Policy">
  <div mat-dialog-title id="modal-header">
    <h2 class="modal-title">Generative AI Usage Policy</h2>
    <button
      type="button"
      class="icon-close"
      aria-label="Close disclaimer"
      (click)="onCloseClick()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div mat-dialog-content id="modal-content">
    <markdown class="md-data" [data]="message"></markdown>
  </div>

  <div class="checkbox-section" [ngClass]="{ disabled: isAccepted }">
    <div class="accept-terms" [ngClass]="{ checked: isChecked }">
      <mat-checkbox
        [(ngModel)]="isChecked"
        class="accept-checkbox"
        [disabled]="isAccepted"
      ></mat-checkbox>
      <span class="accept-text">
        I acknowledge that I have read and understood the information provided
        above and consent to the use of Test AI GenAI capabilities as described.
      </span>
    </div>
  </div>

  <div id="modal-footer">
    @if (!isAccepted) {
    <button class="btn-secondary-s" type="button" (click)="onCancelClick()">
      <img class="m-r-10 m-l-10" alt="separator icon" src="assets\images\prevArrow.svg" />
      Cancel and back to all Projects
    </button>
    <button class="btn-primary-s" type="button" [disabled]="!isChecked" (click)="onConfirm()">
      Confirm
    </button>
    } @else {
    <button class="btn-secondary-s" type="button" (click)="onCloseClick()">Close</button>
    }
  </div>
</div>
